<template>
  <div style="width: 100%;height: 100%;" class="body4">
    <div class="all">
      <div class="main">
        <div class="wraper">
          <div class="position2">
            <div class="wraper"><p> <a href="javascript:void(0)" @click="urlTo('policyServiceWebIndex')">政策文件</a> / <span>政策文件详情</span></p></div>
          </div>
          <div class="details">
            <h2 class="details_tit1">{{detail.title}}</h2>
            <p class="details_time" style="display: none">
              <span> 发布日期：{{detail.policy_date}}</span>
            </p>
            <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab">
              <tr>
                <td width="8%" class="grey">政策名称</td>
                <td width="40%">{{detail.title}}</td>
                <td width="8%" class="grey">发布机构</td>
                <td width="40%">{{detail.party_name}}</td>
              </tr>
              <tr>
                <td class="grey">文号</td>
                <td>{{detail.policy_number}}</td>
                <td class="grey">政策级别</td>
                <td>{{detail.policy_grade_name}}</td>
              </tr>
              <tr>
                <td class="grey">主题分类</td>
                <td>{{detail.policy_at_name}}</td>
                <td class="grey">公文种类</td>
                <td>{{detail.policy_type_name}}</td>
              </tr>
              <tr>
                <td class="grey" >摘要</td>
                <td colspan="3" style="padding-top: 5px;padding-bottom: 5px;">{{detail.policy_abstract}}</td>
              </tr>
              <tr>
                <td class="grey">发布时间</td>
                <td>{{detail.policy_date}}</td>
                <td class="grey">附件下载</td>
                <td><a  v-for="item in detail.attachDataList" :href="getFileUrl(item.attach_id)" target="_blank" style="margin-right: 10px;display: block" >【{{item.attach_name}}】</a></td>
              </tr>
            </table>
            <!--<h3 class="details_tit2">{{detail.policy_abstract}}</h3>-->
            <div class="details_con">
              <div class="details_con_left" style="width: 97%;margin: 0 auto;">
                <dl>
                  <dd id="content"></dd>
                </dl>
<!--                <p v-if="!this.$util.isEmpty(detail.attachIdList)">附件：<a href="javascript:void(0)" @click="downloadAttach">{{detail.title}}</a></p>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div>
  </div>
</template>

<script>
  import headers from "../../components/Headers";
  import fixedDiv from "../../components/FixedDiv";
  import footers from "../../components/Footer";

  export default {
    name: "PolicyDetail",
    components: {
      headers, fixedDiv, footers
    },
    data() {
      return {
        detail: {},
        detail_id: ''
      }
    },
    created() {
      this.detail_id = this.$route.query.detail_id;
      this.getDetail();
    },
    methods: {
      getFileUrl(a){
        return this.$util.getAttach(a)
      },
      //获取政策文件详细
      getDetail() {
        this.$https.post("/api/policy/getPolicy.do", {data_id: this.detail_id}, response => {
          if (response.status === 200 && response.data.code === 200) {
            this.detail = response.data.data;
            $('#content').html(this.detail.data_content)
          }
        });
      },
      urlTo(url,params){
        this.$router.push({path:url,query:params||{}});
      },
      //下载附件
      downloadAttach() {
        // this.$https.downloadFile("/attach/download.do", {attachId: this.detail.attachIdList[0],}, response => {
        // });
      }
    }
  }
</script>

<style scoped>
  .body4{
    background:#f7f7f7 ;
  }
</style>



// WEBPACK FOOTER //
// src/pages/detail/PolicyDetailWeb.vue